// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articlesContent_kUTBW {
    display: flex;
    flex-direction: column;

    ul {
      margin: 0;
    }
    .article_YDt4z {
      .articleTitle_hozo6,
      .articleInfo_osbno {
        color: #1a1a1a;
        font-weight: 400;
      }
      .articleTitle_hozo6 {
        margin: 15px 0;
        font-weight: 300;
        cursor: pointer;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        svg {
          transform: rotate(-90deg);
          -webkit-transform: rotate(-90deg);
          -moz-transform: rotate(-90deg);
          -ms-transform: rotate(-90deg);
          -o-transform: rotate(-90deg);
        }
      }
      .articleInfo_osbno {
        margin: 20px 0;
        interpolate-size: allow-keywords;
        transition: all 300ms;
        -webkit-transition: all 300ms;
        -moz-transition: all 300ms;
        -ms-transition: all 300ms;
        -o-transition: all 300ms;
      }
    }
  }

  .YourAccountConfigIcons_TwaON {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .ConectionsGrayIcon_S3KwI {
    width: fit-content;
    margin: 0 auto;
  }
  .iconsLogoContainer_BBElx {
    margin: 10px auto;
    width: fit-content;
  }
  .iconLogos_lNIUD {
    display: inline-block;
    svg {
      height: 50px;
      width: 50px;
    }
  }
  .bottomMenu_wZjgM {
    display: flex;
    align-items: center;
    bottom: 10px;
    left: 10px;
    color: #2222226d;
    max-height: 25px;
    flex: 1 1;
    strong{
        color: var(--_2-color);
      }
    span {
      color: var(--_2-color);
    }
    .icon_IDeHX {
      cursor: pointer;
    }
    .houseContainer_mthzN {
      height: 30px;
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 99px;
      -webkit-border-radius: 99px;
      -moz-border-radius: 99px;
      -ms-border-radius: 99px;
      -o-border-radius: 99px;
      border: 1px solid #DCDCDC;
      background-color: var(--f5-background);
      cursor: pointer;

      .house_Hrmx7 {
        height: 15px;
        width: 15px;
        fill: var(--_2-color);
        opacity: 0.5;
      }
    }
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/HelpPage/DocumentManagement/DocumentManagement.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;;IAEtB;MACE,SAAS;IACX;IACA;MACE;;QAEE,cAAc;QACd,gBAAgB;MAClB;MACA;QACE,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B;UACE,yBAAyB;UACzB,iCAAiC;UACjC,8BAA8B;UAC9B,6BAA6B;UAC7B,4BAA4B;QAC9B;MACF;MACA;QACE,cAAc;QACd,gCAAgC;QAChC,qBAAqB;QACrB,6BAA6B;QAC7B,0BAA0B;QAC1B,yBAAyB;QACzB,wBAAwB;MAC1B;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB;MACE,YAAY;MACZ,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,SAAO;IACP;QACI,sBAAsB;MACxB;IACF;MACE,sBAAsB;IACxB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;MACZ,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,mBAAmB;MACnB,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,yBAAyB;MACzB,sCAAsC;MACtC,eAAe;;MAEf;QACE,YAAY;QACZ,WAAW;QACX,qBAAqB;QACrB,YAAY;MACd;IACF;EACF","sourcesContent":[".articlesContent {\n    display: flex;\n    flex-direction: column;\n\n    ul {\n      margin: 0;\n    }\n    .article {\n      .articleTitle,\n      .articleInfo {\n        color: #1a1a1a;\n        font-weight: 400;\n      }\n      .articleTitle {\n        margin: 15px 0;\n        font-weight: 300;\n        cursor: pointer;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        svg {\n          transform: rotate(-90deg);\n          -webkit-transform: rotate(-90deg);\n          -moz-transform: rotate(-90deg);\n          -ms-transform: rotate(-90deg);\n          -o-transform: rotate(-90deg);\n        }\n      }\n      .articleInfo {\n        margin: 20px 0;\n        interpolate-size: allow-keywords;\n        transition: all 300ms;\n        -webkit-transition: all 300ms;\n        -moz-transition: all 300ms;\n        -ms-transition: all 300ms;\n        -o-transition: all 300ms;\n      }\n    }\n  }\n\n  .YourAccountConfigIcons {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  .ConectionsGrayIcon {\n    width: fit-content;\n    margin: 0 auto;\n  }\n  .iconsLogoContainer {\n    margin: 10px auto;\n    width: fit-content;\n  }\n  .iconLogos {\n    display: inline-block;\n    svg {\n      height: 50px;\n      width: 50px;\n    }\n  }\n  .bottomMenu {\n    display: flex;\n    align-items: center;\n    bottom: 10px;\n    left: 10px;\n    color: #2222226d;\n    max-height: 25px;\n    flex: 1;\n    strong{\n        color: var(--_2-color);\n      }\n    span {\n      color: var(--_2-color);\n    }\n    .icon {\n      cursor: pointer;\n    }\n    .houseContainer {\n      height: 30px;\n      width: 30px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 99px;\n      -webkit-border-radius: 99px;\n      -moz-border-radius: 99px;\n      -ms-border-radius: 99px;\n      -o-border-radius: 99px;\n      border: 1px solid #DCDCDC;\n      background-color: var(--f5-background);\n      cursor: pointer;\n\n      .house {\n        height: 15px;\n        width: 15px;\n        fill: var(--_2-color);\n        opacity: 0.5;\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articlesContent": `articlesContent_kUTBW`,
	"article": `article_YDt4z`,
	"articleTitle": `articleTitle_hozo6`,
	"articleInfo": `articleInfo_osbno`,
	"YourAccountConfigIcons": `YourAccountConfigIcons_TwaON`,
	"ConectionsGrayIcon": `ConectionsGrayIcon_S3KwI`,
	"iconsLogoContainer": `iconsLogoContainer_BBElx`,
	"iconLogos": `iconLogos_lNIUD`,
	"bottomMenu": `bottomMenu_wZjgM`,
	"icon": `icon_IDeHX`,
	"houseContainer": `houseContainer_mthzN`,
	"house": `house_Hrmx7`
};
export default ___CSS_LOADER_EXPORT___;
